var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({class:[
    _vm.mainClass,
    _vm.$attrs.class,
  ],style:([
    _vm.$attrs.style,
  ]),attrs:{"value":_vm.value,"append-icon":"mdi-chevron-down","color":_vm.defaultColor,"persistent-placeholder":""},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([(_vm.$scopedSlots.selection)?{key:"selection",fn:function(slotProps){return [_vm._t("selection",null,null,slotProps)]}}:null],null,true)},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }